export default __webpack_public_path__ + "static/media/telegram_logo_white.d6ec21f3.svg";